export const DEFAULT_FEED_SETTINGS = {
  customerName: true,
  address: true,
  jobTotal: false,
  jobTime: true,
  locationPin: true,
  photo: true,
  review: true,
  mxplan: true,
  upsell: true,
  yardsign: true,
  revenuecredit: true,
  revperhour: true,
  service: true,
};

export const isRevPerHourKpiTitle = (title) => {
  const t = (title || "").toLowerCase();
  return t.includes("per hour") || t.includes("rev per") || /\brph\b/.test(t);
};

export const isRevenueCreditKpiTitle = (title) => {
  if (isRevPerHourKpiTitle(title)) return false;
  const t = (title || "").toLowerCase();
  return t.includes("revenue credit") || (t.includes("revenue") && t.includes("credit"));
};

/** Map a KPI title to its feed settings toggle key. */
export const kpiSettingsKey = (title) => {
  const t = (title || "").toLowerCase();
  if (isRevPerHourKpiTitle(title)) return "revperhour";
  if (isRevenueCreditKpiTitle(title)) return "revenuecredit";
  if (t.includes("up") && t.includes("sell")) return "upsell";
  if (t.includes("upsell")) return "upsell";
  if (t.includes("mx") || t.includes("plan") || t.includes("member")) return "mxplan";
  if (t.includes("review")) return "review";
  if (t.includes("yard")) return "yardsign";
  return null;
};

export const shouldShowFeedKpi = (title, settings) => {
  const key = kpiSettingsKey(title);
  if (key == null) return true;
  return settings?.[key] !== false;
};

/**
 * Decide whether a workspace KPI should be shown in the feed.
 *
 * Feed Settings toggles are now keyed by KPI id (one per live workspace
 * metric), so prefer an explicit per-id toggle when present. Falls back to the
 * legacy title-based category key for back-compat with previously saved
 * settings and other consumers (e.g. Live TV). A KPI with neither an id toggle
 * nor a recognized title category defaults to visible.
 *
 * @param {{_id?: string, title?: string}} kpi
 * @param {object} settings
 */
export const shouldShowFeedKpiEntry = (kpi, settings) => {
  if (!kpi) return true;
  const id = kpi._id != null ? String(kpi._id) : null;
  if (id && settings && Object.prototype.hasOwnProperty.call(settings, id)) {
    return settings[id] !== false;
  }
  return shouldShowFeedKpi(kpi.title, settings);
};

export const loadFeedSettings = () => {
  const savedSettings = window.sessionStorage.getItem("feedSettings");
  if (savedSettings) {
    return { ...DEFAULT_FEED_SETTINGS, ...JSON.parse(savedSettings) };
  }
  window.sessionStorage.setItem("feedSettings", JSON.stringify(DEFAULT_FEED_SETTINGS));
  return { ...DEFAULT_FEED_SETTINGS };
};
